import React from "react";
import { Link, useParams } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { blogPosts } from "./blogData";

const articleStyle = {
  maxWidth: "680px",
  margin: "0 auto",
  lineHeight: "1.8",
  fontSize: "1.05rem",
};

const h2Style = {
  fontSize: "1.5rem",
  fontWeight: "700",
  marginTop: "2.5rem",
  marginBottom: "0.75rem",
  lineHeight: "1.3",
};

const h3Style = {
  fontSize: "1.05rem",
  fontWeight: "600",
  marginTop: "1.5rem",
  marginBottom: "0.6rem",
};

const pStyle = {
  marginBottom: "1.8rem",
  lineHeight: "1.8",
};

function Blog_detail({ url, Dissconnect, Metamask, WalletC }) {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div>
        <Navbar
          Dissconnect={Dissconnect}
          Metamask={Metamask}
          WalletC={WalletC}
        />
        <div
          className="container-kws p-t-5 p-b-5"
          style={{ textAlign: "center" }}
        >
          <h1 className="f-s-2 f-w-600 m-b-1">Article not found</h1>
          <Link to="/blog" className="b_clr">
            ← Back to Blog
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const { content } = post;

  return (
    <div>
      <Navbar Dissconnect={Dissconnect} Metamask={Metamask} WalletC={WalletC} />

      <div className="container-kws p-t-2 p-b-5">
        {/* Back link */}
        <div style={articleStyle} className="m-b-2">
          <Link
            to="/blog"
            className="b_clr"
            style={{ fontSize: "0.9rem", textDecoration: "none" }}
          >
            ← Blog
          </Link>
        </div>

        {/* Header */}
        <div style={articleStyle} className="m-b-3">
          <div
            className="b_clr"
            style={{
              fontSize: "0.8rem",
              fontWeight: "600",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              marginBottom: "0.75rem",
            }}
          >
            {post.category}
          </div>
          <h1
            style={{
              fontSize: "clamp(1.7rem, 3.5vw, 2.4rem)",
              fontWeight: "800",
              lineHeight: "1.25",
              marginBottom: "1rem",
            }}
          >
            {post.title}
          </h1>
          <div className="g_clr" style={{ fontSize: "0.9rem" }}>
            {post.date}
          </div>
          <hr style={{ marginTop: "1.5rem", opacity: "0.2" }} />
        </div>

        {/* Body */}
        <div style={articleStyle}>
          {/* Opening paragraphs */}
          {content.openingParagraphs.map((para, i) => (
            <div key={i} style={pStyle}>
              {para}
            </div>
          ))}

          {/* Subheading */}
          {content.subheading && (
            <div style={{ ...pStyle, fontWeight: "600" }}>
              {content.subheading}
            </div>
          )}

          {/* Image + text intro layout */}
          {content.imageIntro && (
            <div style={{ marginBottom: "2rem" }}>
              <div style={{ overflow: "hidden" }}>
                <img
                  src={content.imageIntro.image}
                  alt=""
                  style={{
                    float: "left",
                    width: "130px",
                    height: "130px",
                    objectFit: "contain",
                    marginRight: "2.5rem",
                    marginBottom: "0.5rem",
                    borderRadius: "8px",
                  }}
                />
                {content.imageIntro.paragraphs.map((para, i) => {
                  const isLast = i === content.imageIntro.paragraphs.length - 1;
                  return (
                    <div key={i} style={pStyle}>
                      {para}
                      {isLast && content.imageIntro.link && (
                        <>
                          {" "}
                          <a
                            href={content.imageIntro.link.href}
                            className="b_clr"
                            target="_blank"
                            rel="noreferrer"
                          >
                            {content.imageIntro.link.label}
                          </a>
                        </>
                      )}
                    </div>
                  );
                })}
              </div>
              <div style={{ clear: "both" }} />
            </div>
          )}

          {/* Body paragraphs */}
          {content.bodyParagraphs &&
            content.bodyParagraphs.map((para, i) => (
              <div key={i} style={pStyle}>
                {para}
              </div>
            ))}

          {/* Providers (provider-list posts) */}
          {content.providers &&
            content.providers.map((provider) => (
              <div key={provider.rank} style={{ marginTop: "3rem" }}>
                <h2 style={h2Style}>
                  {provider.rank}. {provider.name}
                </h2>

                <div style={{ ...pStyle, fontStyle: "italic" }}>
                  <strong>Best for: {provider.bestFor}:</strong>{" "}
                  {provider.bestForDesc}
                </div>

                {/* Intro description */}
                {provider.description.map((para, i) => (
                  <React.Fragment key={i}>
                    <div style={pStyle}>{para}</div>
                    {i === 0 && provider.image && (
                      <img
                        src={provider.image}
                        alt={provider.name}
                        style={{
                          width: "100%",
                          borderRadius: "10px",
                          marginBottom: "1.5rem",
                          display: "block",
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}

                {/* Where This Tool Shines */}
                {provider.shines && (
                  <>
                    <h3 style={h3Style}>Where This Tool Shines</h3>
                    {provider.shines.map((para, i) => (
                      <div key={i} style={pStyle}>
                        {para}
                      </div>
                    ))}
                  </>
                )}

                {/* Key Features */}
                <h3 style={h3Style}>Key Features</h3>
                <ul style={{ paddingLeft: "1.25rem", marginBottom: "1.8rem" }}>
                  {provider.features.map((feature, i) => (
                    <li
                      key={i}
                      style={{ marginBottom: "0.75rem", lineHeight: "1.7" }}
                    >
                      <strong>{feature.name}:</strong> {feature.desc}
                    </li>
                  ))}
                </ul>

                {/* Best For */}
                {provider.bestForSection && (
                  <>
                    <h3 style={h3Style}>Best For</h3>
                    <div style={pStyle}>{provider.bestForSection}</div>
                  </>
                )}

                {/* Pricing */}
                <h3 style={h3Style}>Pricing</h3>
                <div style={pStyle}>{provider.pricing}</div>

                <hr style={{ opacity: "0.15", marginTop: "0.5rem" }} />
              </div>
            ))}

          {/* Sections (article-style posts) */}
          {content.sections &&
            content.sections.map((section, sIdx) => (
              <div key={sIdx} style={{ marginTop: "2.5rem" }}>
                {section.heading && <h2 style={h2Style}>{section.heading}</h2>}

                {section.paragraphs &&
                  section.paragraphs.map((para, i) => (
                    <div key={i} style={pStyle}>
                      {para}
                    </div>
                  ))}

                {section.boldParagraphs &&
                  section.boldParagraphs.map((b, i) => (
                    <div key={i} style={pStyle}>
                      <strong>{b.bold}</strong>
                      {b.text}
                    </div>
                  ))}

                {section.profileTable && (
                  <div style={{ marginBottom: "1.8rem" }}>
                    {section.profileTable.map((row, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          gap: "0.5rem",
                          marginBottom: "0.4rem",
                          lineHeight: "1.7",
                        }}
                      >
                        <span style={{ fontWeight: "600", minWidth: "200px" }}>
                          {row.label}:
                        </span>
                        <span>{row.value}</span>
                      </div>
                    ))}
                  </div>
                )}

                {section.bullets && (
                  <ul
                    style={{ paddingLeft: "1.25rem", marginBottom: "1.8rem" }}
                  >
                    {section.bullets.map((b, i) => (
                      <li
                        key={i}
                        style={{ marginBottom: "0.75rem", lineHeight: "1.7" }}
                      >
                        {b.bold && <strong>{b.bold}</strong>}
                        {b.text}
                      </li>
                    ))}
                  </ul>
                )}

                {section.orderedList && (
                  <ol
                    style={{ paddingLeft: "1.25rem", marginBottom: "1.8rem" }}
                  >
                    {section.orderedList.map((item, i) => (
                      <li
                        key={i}
                        style={{ marginBottom: "0.75rem", lineHeight: "1.7" }}
                      >
                        {item}
                      </li>
                    ))}
                  </ol>
                )}

                {section.afterParagraphs &&
                  section.afterParagraphs.map((para, i) => (
                    <div key={i} style={pStyle}>
                      {para}
                    </div>
                  ))}

                {section.subsections &&
                  section.subsections.map((sub, subIdx) => (
                    <div key={subIdx} style={{ marginTop: "1.5rem" }}>
                      {sub.headingBold ? (
                        <div
                          style={{
                            ...pStyle,
                            fontWeight: "700",
                            marginBottom: "0.5rem",
                          }}
                        >
                          {sub.heading}
                        </div>
                      ) : (
                        <h3 style={h3Style}>{sub.heading}</h3>
                      )}
                      {sub.paragraphs &&
                        sub.paragraphs.map((para, i) => (
                          <div key={i} style={pStyle}>
                            {para}
                          </div>
                        ))}
                      {sub.bullets && (
                        <ul
                          style={{
                            paddingLeft: "1.25rem",
                            marginBottom: "1.8rem",
                          }}
                        >
                          {sub.bullets.map((b, i) => (
                            <li
                              key={i}
                              style={{
                                marginBottom: "0.75rem",
                                lineHeight: "1.7",
                              }}
                            >
                              {b.bold && <strong>{b.bold}</strong>}
                              {b.text}
                            </li>
                          ))}
                        </ul>
                      )}
                      {sub.afterParagraphs &&
                        sub.afterParagraphs.map((para, i) => (
                          <div key={i} style={pStyle}>
                            {para}
                          </div>
                        ))}
                    </div>
                  ))}

                <hr style={{ opacity: "0.15", marginTop: "1.5rem" }} />
              </div>
            ))}

          {/* Conclusion */}
          <div style={{ marginTop: "3rem" }}>
            <h2
              style={{
                ...h2Style,
                ...(content.conclusion.title === "Disclaimer" && {
                  fontSize: "0.9rem",
                  fontWeight: "400",
                }),
              }}
            >
              {content.conclusion.title}
            </h2>
            {content.conclusion.paragraphs.map((para, i) => (
              <div
                key={i}
                style={{
                  ...pStyle,
                  ...(content.conclusion.title === "Disclaimer" && {
                    fontSize: "0.9rem",
                    fontStyle: "italic",
                    opacity: 0.7,
                  }),
                }}
              >
                {para}
              </div>
            ))}
            {content.conclusion.boldParagraphs &&
              content.conclusion.boldParagraphs.map((p, i) => (
                <div key={i} style={pStyle}>
                  <strong>{p.bold}</strong>
                  {p.text}
                </div>
              ))}
            {content.conclusion.afterParagraphs &&
              content.conclusion.afterParagraphs.map((para, i) => (
                <div key={i} style={pStyle}>
                  {para}
                </div>
              ))}
          </div>

          {/* Back link */}
          <div
            style={{
              marginTop: "3rem",
              paddingTop: "1.5rem",
              borderTop: "1px solid rgba(128,128,128,0.2)",
            }}
          >
            <Link
              to="/blog"
              className="b_clr"
              style={{ fontSize: "0.9rem", textDecoration: "none" }}
            >
              ← Back to Blog
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Blog_detail;
